/**
 * @module app.bdc.reports.bdcTabacPresseCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {

    function BDCTabacPresseCtrl(
        $scope,
        $window,
        $rootScope,
        pricesService,
        commonService,
        orderService,
        marketService,
        tillPackService,
        boulangerieService,
        offerService,
        goodwillGesturesService,
        promotionService,
        bdcTabacPresseService,
        userService
    ) {
        var self = {};
        self.commonService = commonService;

        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('/bdc/list');
        }

        self.user = $rootScope.user;
        self.order = $rootScope.order;

        self.goodwillGesturesService = goodwillGesturesService;

        // Init the services properties
        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);
        goodwillGesturesService.setOrderForm(self.orderForm);

        self.getAmountFinanced = () => {
            return pricesService.getAmountFinanced();
        }

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            if(self.order.isSigned){
                return moment(self.order.dateSignature).format('DD/MM/YYYY');
            }
            return moment().format('DD/MM/YYYY');
        };

        self.getDateLimitInstall = ()=> {
            return moment(self.order.dateInstallation).endOf('month').format('MMMM YYYY');
        }

        self.getDateLimiteQuickInstallOffer = ()=> {
            return self.order.isSigned ?
                moment(self.order.dateSignature).isBefore('2026-01-20') ?
                    moment(self.order.dateSignature).add({days: 60}).endOf('month').format('DD/MM/YYYY')
                    : moment(self.order.dateSignature).add({days: 90}).endOf('month').format('DD/MM/YYYY')
                : moment(self.order.dateUpdated).add({days: 90}).endOf('month').format('DD/MM/YYYY');
        }

        self.getRDS = () => {
            if(self.order.isSigned){
                let rds = userService.findPerson(self.order.RDSRef);
                return rds.user.firstname + ' ' + rds.user.lastname;
            }
            return self.user.firstname + ' ' + self.user.lastname;
        }

        self.applyDiscountRate = function (discount){
            return pricesService.applyDiscountRate(discount);
        }

        self.getContractTypeValue = pricesService.getContractTypeValue();
        self.contractMonths = orderService.getContractMonths(self.order);

        self.nbTills = orderService.getNbTills(self.order.tills);
        self.isRental = orderService.isRental(self.order.contract.contractType.code);

        self.isBoulangerieMarket = marketService.isBoulangerieMarket(self.order);
        self.isTabacPresseMarket = marketService.isTabacPresseMarket(self.order);
        self.isAutreMarket = marketService.isAutreMarket(self.order);

        self.isUpsOnly = self.order.goodwillGestures && self.order.goodwillGestures.scanupServices
            && self.order.goodwillGestures.scanupServices.isUPS && !self.order.goodwillGestures.scanupServices.isBrinks

        self.columnWidth = self.order.contract.scenarioType.code === 'PERIPHERIQUE' ? 'w40' : 'w50';

        // BT or BT+ offer
        self.is2017Offer = tillPackService.is2017TillPack(self.order.tills, self.order.orderType.code);
        self.isBtouchPlusPack = function isBtouchPlusPack() {
            return tillPackService.isBtouchPlusPack(self.order.tills);
        };

        self.isBtouchPack = function isBtouchPack() {
            return tillPackService.isBtouchPack(self.order.tills);
        };

        // ESSENTIEL or PREMIUM offer
        self.isOlderOffer = offerService.isOlderOffer(self.order);

        self.promotions = promotionService.getPromotions();

        /**
         * Get the date installation, only defined when the order has been signed
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation() {
            return self.order.dateInstallation
                ? moment(self.order.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                : null;
        };

        self.getInsuranceTotalWithoutMDS = function getInsuranceTotalWithoutMDS() {
            return pricesService.getMaintenancePrices();
        };

        self.getTillPackDescription = function getTillPackDescription(tillType) {
            if (tillType === 'ESSENTIEL') {
                return 'TPV B Touch pied standard, afficheur 2 lignes, imprimante tickets';
            }
            else if (tillType === 'PREMIUM') {
                return 'TPV B Touch pied standard, écran consommateur, imprimante tickets';
            }
            else if (tillType === 'BS_ESSENTIEL') {
                return 'TPV B Smart pied standard, afficheur 2 lignes, imprimante tickets';
            }
            else if (tillType === 'BS_PREMIUM') {
                return 'TPV B Smart pied standard, écran consommateur, imprimante tickets';
            }
            else if (tillType === 'BM') {
                return "TPV B Moov, dock de chargement, logiciel d'encaissement et de gestion Bimedia, 1 clavier";
            }
            else if (tillType === 'BG_ESSENTIEL') {
                return 'TPV B Green pied standard, afficheur 2 lignes, imprimante tickets';
            }
            else if (tillType === 'BG_PREMIUM') {
                return 'TPV B Green pied standard, écran consommateur, imprimante tickets';
            }
            else if(tillType === 'FORFAIT') {
                return 'Forfait maintien de garantie sur materiel existant'
            }
            else if(tillType === 'PREMIUM_RECONDITIONNE') {
                return 'TPV B Touch pied standard reconditionné, écran consommateur, imprimante tickets'
            }
            else if (tillType === 'BM+') {
                return "TPV B Moov+, 1 clavier, 1 support basic";
            }else if (tillType === 'BSW_ESSENTIEL') {
                return 'TPV B Swift pied standard, afficheur 2 lignes, imprimante tickets';
            }
            else if (tillType === 'BSW_PREMIUM') {
                return 'TPV B Swift pied standard, écran consommateur, imprimante tickets';
            }
            else if (tillType === 'BW_ESSENTIEL') {
                return 'TPV B Wide pied standard, afficheur 2 lignes, imprimante tickets';
            }
            else if (tillType === 'BW_PREMIUM') {
                return 'TPV B Wide pied standard, écran consommateur, imprimante tickets';
            }
            else if (tillType === 'BC_ESSENTIEL') {
                return 'TPV B Compact, imprimante tickets';
            }
            return '';
        };

        self.getTillsConfig = function getTillsConfig() {
            return self.order.tills.map(function(till) {
                var index = till.label.indexOf('Config') > -1 ? till.label.indexOf('Config') + 10 : 0; // 10 = 'Config 1 :' length in all tills' labels
                return { amount: till.nbTills, label: till.label.slice(index) };
            });
        };

        self.getCashDrawers = function getCashDrawers() {
            return self.order.cashDrawers.filter(function(cashDrawer) {
                return cashDrawer.nbCashDrawers > 0;
            });
        };

        /* Extension de garantie */
        self.isWarrantyExtension = function isWarrantyExtension() {
            return self.extension.length > 0 && self.olderOffer === true;
        };

        self.displayWarrantyDuration = function displayWarrantyDuration() {
            return self.extension.length === 2 ? '60' : self.extension.length === 1 ? '48' : self.getContractTypeValue;
        };

        self.getWarrantyExtensionProposal = function getWarrantyExtensionProposal() {
            var oneYearProposal = { duration: '12', price: '500' };
            var twoYearProposal = { duration: '24', price: '1000' };
            return self.order.contract.contractType.code === 'LOC48' ||
                self.order.contract.contractType.code === 'ACHAT'
                ? oneYearProposal
                : twoYearProposal;
        };

        /* Accessoires caisse */
        self.displayAccessoriesPrices = function displayAccessoriesPrices(option, price) {
            if (self.isOlderOffer === true) {
                return pricesService.getTillAccessoriesPrice(price, self.nbTills);
            }
            else {
                return pricesService.getOptionUnitPrice(option, false, true) * option.nbOptions;
            }
        };

        self.displayBoulangerieSoftwareUnitPrice = function displayBoulangerieSoftwareUnitPrice(option) {
            return pricesService.getOptionUnitPrice(option);
        };

        self.displayOptionUnitPrice = function displayOptionUnitPrice(option, isAdditionalOption) {
            return pricesService.getOptionUnitPrice(option, isAdditionalOption, true);
        };

        /**
         * Construct the text bloc to display in the BDC
         * It contains the revenue values depending on the type
         * @param type
         * @returns {string}
         */
        self.listRevenueLevels = function listRevenueLevels(type) {
            var list = '';

            if (self.order.goodwillGestures && self.order.goodwillGestures.revenue.rateValue && type) {
                // Get the active revenues
                var revenueLevels = goodwillGesturesService.getRevenues(type, self.order);

                let symbol = type.indexOf('GLADY') > -1 ? ' points' : '€';

                // Construct the string
                list = revenueLevels
                    .map(function(revenue) {
                        let labelMatch = /\(([^)]+)\)/.exec(revenue.rateLabel);
                        if(labelMatch && labelMatch[1])
                            return /\(([^)]+)\)/.exec(revenue.rateLabel)[1] + '=' + revenue.rateValue + symbol;
                        return revenue.rateLabel.split(' -')[0] + '=' + revenue.rateValue + symbol;
                    })
                    .join(' / ');
            }

            return list;
        };

        self.displayWelcomeBonus = function displayWelcomeBonus() {
            var welcomeBonusLabel = '';
            if (goodwillGesturesService.isWelcomeBonusConquestType(self.order)) {
                var welcomeBonusLabel = ' de ' + goodwillGesturesService.WELCOME_BONUSES.CONQUETE.label;
            }
            else if (goodwillGesturesService.isWelcomeBonusRenewalType(self.order)) {
                var welcomeBonusLabel = ' de ' + goodwillGesturesService.WELCOME_BONUSES.RENOUVELLEMENT.label;
            }
            return self.order.goodwillGestures.amount.welcomeBonus + ' € HT de prime' + welcomeBonusLabel;
        };

        self.getFirstRentalSubtotal = function getFirstRentalSubtotal() {
            if (self.is2017Offer || self.isOlderOffer === false) {
                return self.order.prices.leaserSubtotal;
            }
            else {
                return self.tills['BH+'].price + self.tills['BF'].price + self.order.prices.reintegration;
            }
        };

        self.getBuralogUnitPriceTotal = function getBuralogUnitPriceTotal() {
            let prices;
            var options = self.buralogOptions;
            prices = options.map(function(option) {
                return pricesService.getOptionUnitPrice(option);
            });
            if (self.order.goodwillGestures && self.order.goodwillGestures.amount.launchBBooster) {
                prices.push(-goodwillGesturesService.LAUNCH_B_BOOSTER_MONTHLY_AMOUNT);
            }
            // Add unit insurance price to all buralog options prices array
            if (self.isTabacPresseMarket === true || self.isAutreMarket === true) {
                prices.push(
                    pricesService.getInsuranceUnitPrice(self.order.orderType, orderService.getNbTills(self.order.tills))
                );
            }
            return pricesService.sumPrices(prices, 0);
        };

        self.getPurchaseOptionSubtotal = function getPurchaseOptionSubtotal() {
            var purchaseTPEOptions = self.TpeOptions;
            let purchaseBBoosterOption = self.BBoosterOptions;
            let scanupPrices = { devices: 0, options: 0 };
            let prestationsPrices = { install : 0, cateringSupport: 0};
            let launchBimediaPay = 0;
            var tpePrices = 0;
            if (!self.isRental) {
                tpePrices = self.getTpeSubtotal();
            }
            if (!self.isLeasingScanup) {
                scanupPrices = self.scanupPrices;
                if (self.order.goodwillGestures && self.order.goodwillGestures.amount.launchBimediaPay > 0) {
                    launchBimediaPay = goodwillGesturesService.LAUNCH_BIMEDIA_PAY_MONTHLY_AMOUNT;
                }
            }
            if(!self.isLeasingPrestationInstall) {
                prestationsPrices = self.prestationsPrices;
            }
            var tpeOptionPrices = purchaseTPEOptions.map(function(option) {
                return pricesService.getOptionUnitPrice(option);
            });

            let BBoosterOptionPrices = purchaseBBoosterOption.map(function(option) {
                if (
                    option.billingTypeCode === 'ACHAT' &&
                    !(self.order.goodwillGestures && self.order.goodwillGestures.amount.launchBBooster)
                ) {
                    return pricesService.getOptionUnitPrice(option);
                }
                return 0;
            });

            return (
                pricesService.sumPrices(tpeOptionPrices, 0) +
                tpePrices +
                pricesService.sumPrices(BBoosterOptionPrices, 0) +
                scanupPrices.devices +
                scanupPrices.options -
                launchBimediaPay +
                prestationsPrices.install +
                prestationsPrices.cateringSupport
            );
        };

        self.getTpeSubtotal = function getTpeSubtotal() {
            var tpe;
            self.TPEsOffered.length > 0 ? (tpe = self.TPEsOffered) : (tpe = self.TPEs);
            var tpeTotalPrices = tpe.map(function(option) {
                return pricesService.getOptionUnitPrice(option);
            });

            tpeTotalPrices = pricesService.sumPrices(tpeTotalPrices, 0);
            return tpeTotalPrices;
        };

        /**
         * Get the translated order contract type
         * @param  {String} contractType
         * @return {String}
         */
        self.getContractType = function getContractType(contractType) {
            if (contractType === 'ACHAT') {
                return 'Paiement comptant';
            }

            if (contractType === 'LOC48') {
                return 'Location sur 48 mois';
            }

            if (contractType === 'LOC36') {
                return 'Location sur 36 mois';
            }

            return 'Location sur 60 mois';
        };

        self.displayInsuranceUnitPrice = function displayInsuranceUnitPrice() {
            return pricesService.getInsuranceUnitPrice(self.order.orderType, orderService.getNbTills(self.order.tills));
        };

        /**
         * Make a for in the view
         * @param  {int} min
         * @param  {int} max
         * @param  {int} step
         * @return {Array}
         */
        self.range = function(min, max, step) {
            step = step || 1;
            var input = [];
            for (var i = min; i <= max; i += step) {
                input.push(i);
            }
            return input;
        };

        /**
         * Generate the tills object
         * @return {Object}
         */
        self.tills = (function() {
            // TODO: Appeler TillPackService
            var tills = {};
            // Init tills[tillType] with each tillType found in the orderForm
            self.orderForm.tills.forEach(function(till) {
                if (tills[till.tillType.code] === undefined) {
                    tills[till.tillType.code] = {
                        nbTills: 0,
                        orders: [],
                        price: 0
                    };
                }
            });

            tills.isMixed = orderService.areTillsMixed(self.order.tills).isMixed;

            for (var i = 0; i < self.order.tills.length; i++) {
                tills[self.order.tills[i].tillType.code].orders.push(self.order.tills[i]);
                tills[self.order.tills[i].tillType.code].nbTills += self.order.tills[i].nbTills;
            }
            if (self.order.isMultiStores) {
                let degressiveRate = pricesService.getDegressiveRate(self.order, self.nbTills, true);
                let prices = pricesService.getDegressiveRateTillPrices(
                    self.order.contract.contractType.code,
                    degressiveRate
                );
                tills['ESSENTIEL'].price = prices['ESSENTIEL'];
                tills['PREMIUM'].price = prices['PREMIUM'];
                tills['BS_ESSENTIEL'].price = prices['BS_ESSENTIEL'];
                tills['BS_PREMIUM'].price = prices['BS_PREMIUM'];
                tills['BG_ESSENTIEL'].price = prices['BG_ESSENTIEL'];
                tills['BG_PREMIUM'].price = prices['BG_PREMIUM'];
                tills['BM'].price = prices['BM'];
                tills['FORFAIT'].price = prices['FORFAIT'];
                tills['PREMIUM_RECONDITIONNE'].price = prices['PREMIUM_RECONDITIONNE'];
                tills['BM+'].price = prices['BM+'];
                tills['BSW_ESSENTIEL'].price = prices['BSW_ESSENTIEL'];
                tills['BSW_PREMIUM'].price = prices['BSW_PREMIUM'];
                tills['BW_ESSENTIEL'].price = prices['BW_ESSENTIEL'];
                tills['BW_PREMIUM'].price = prices['BW_PREMIUM'];
                tills['BC_ESSENTIEL'].price = prices['BC_ESSENTIEL'];
            }
            else if (tills.isMixed) {
                var mixedPack = {
                    ESSENTIEL: tills['ESSENTIEL'].nbTills,
                    PREMIUM: tills['PREMIUM'].nbTills,
                    BS_ESSENTIEL: tills['BS_ESSENTIEL'].nbTills,
                    BS_PREMIUM: tills['BS_PREMIUM'].nbTills,
                    BG_ESSENTIEL: tills['BG_ESSENTIEL'].nbTills,
                    BG_PREMIUM: tills['BG_PREMIUM'].nbTills,
                    BM: tills['BM'].nbTills,
                    FORFAIT: tills['FORFAIT'].nbTills,
                    PREMIUM_RECONDITIONNE : tills['PREMIUM_RECONDITIONNE'].nbTills,
                    'BM+': tills['BM+'].nbTills,
                    BSW_ESSENTIEL: tills['BSW_ESSENTIEL'].nbTills,
                    BSW_PREMIUM: tills['BSW_PREMIUM'].nbTills,
                    BW_ESSENTIEL: tills['BW_ESSENTIEL'].nbTills,
                    BW_PREMIUM: tills['BW_PREMIUM'].nbTills,
                    BC_ESSENTIEL: tills['BC_ESSENTIEL'].nbTills,
                };
                var prices = pricesService.getMixedTillPrice(mixedPack, self.order.contract.contractType.code);
                tills['ESSENTIEL'].price = prices['ESSENTIEL'];
                tills['PREMIUM'].price = prices['PREMIUM'];
                tills['BS_ESSENTIEL'].price = prices['BS_ESSENTIEL'];
                tills['BS_PREMIUM'].price = prices['BS_PREMIUM'];
                tills['BG_ESSENTIEL'].price = prices['BG_ESSENTIEL'];
                tills['BG_PREMIUM'].price = prices['BG_PREMIUM'];
                tills['BM'].price = prices['BM'];
                tills['FORFAIT'].price = prices['FORFAIT'];
                tills['PREMIUM_RECONDITIONNE'].price = prices['PREMIUM_RECONDITIONNE'];
                tills['BM+'].price = prices['BM+'];
                tills['BSW_ESSENTIEL'].price = prices['BSW_ESSENTIEL'];
                tills['BSW_PREMIUM'].price = prices['BSW_PREMIUM'];
                tills['BW_ESSENTIEL'].price = prices['BW_ESSENTIEL'];
                tills['BW_PREMIUM'].price = prices['BW_PREMIUM'];
                tills['BC_ESSENTIEL'].price = prices['BC_ESSENTIEL'];
            }
            else {
                tills['ESSENTIEL'].price = tills['ESSENTIEL'].nbTills > 0 ? self.order.prices.till : 0;
                tills['PREMIUM'].price = tills['PREMIUM'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BS_ESSENTIEL'].price = tills['BS_ESSENTIEL'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BS_PREMIUM'].price = tills['BS_PREMIUM'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BG_ESSENTIEL'].price = tills['BG_ESSENTIEL'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BG_PREMIUM'].price = tills['BG_PREMIUM'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BM'].price = tills['BM'].nbTills > 0 ? self.order.prices.till : 0;
                tills['FORFAIT'].price = tills['FORFAIT'].nbTills > 0 ? self.order.prices.till : 0;
                tills['PREMIUM_RECONDITIONNE'].price = tills['PREMIUM_RECONDITIONNE'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BM+'].price = tills['BM+'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BSW_ESSENTIEL'].price = tills['BSW_ESSENTIEL'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BSW_PREMIUM'].price = tills['BSW_PREMIUM'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BW_ESSENTIEL'].price = tills['BW_ESSENTIEL'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BW_PREMIUM'].price = tills['BW_PREMIUM'].nbTills > 0 ? self.order.prices.till : 0;
                tills['BC_ESSENTIEL'].price = tills['BC_ESSENTIEL'].nbTills > 0 ? self.order.prices.till : 0;
            }
            return tills;
        })();

        self.printer = null;
        self.printerPrices = pricesService.calculatePrinterPricesTRAD();
        self.additionalPrinter = null;
        self.scanup = null;
        self.scanupInstallation = null;
        self.scanupPrices = pricesService.calculateScanupPrices();
        self.scanupOptions = [];
        self.flashup = [];
        self.prestationInstall = null;
        self.prestationCateringSupport = null
        self.prestationsPrices = pricesService.calculatePrestationsPrices();
        self.tillAccessories = [];
        self.packBoulangerie = [];
        self.software = [];
        self.tillMaintenance = [];
        self.sav = [];
        self.extension = [];
        self.gestion = [];
        self.options = [];
        self.leaserOptions = [];
        self.buralogOptions = [];
        self.TPEs = [];
        self.TPEsOffered = [];
        self.TpeOptions = [];
        self.BBoosterOptions = [];
        self.moneyTransferServices = getMoneyTransferServices();

        var nbDaysTillPartExchange = '';
        var nbDaysScanupPartExchange = '';

        if (self.order.goodwillGestures && self.order.goodwillGestures.amount.tillPartExchange > 0) {
            var tillPartExchange = self.orderForm.partExchange.filter(obj => {
                return (
                    obj.partExchangeTypeCode === 'TILL' &&
                    obj.partExchangeId === self.order.goodwillGestures.amount.tillPartExchangeId
                );
            });
            nbDaysTillPartExchange = tillPartExchange[0].partExchangeNbDays;
        }

        if (self.order.goodwillGestures && self.order.goodwillGestures.amount.scanupPartExchange > 0) {
            var scanupPartExchange = self.orderForm.partExchange.filter(obj => {
                return (
                    obj.partExchangeTypeCode === 'SCANUP' &&
                    obj.partExchangeId === self.order.goodwillGestures.amount.scanupPartExchangeId
                );
            });
            nbDaysScanupPartExchange = scanupPartExchange[0].partExchangeNbDays;
        }

        self.nbDaysPartExchange = nbDaysTillPartExchange ? nbDaysTillPartExchange : nbDaysScanupPartExchange;

        /**
         * Init the data to show the report
         */
        function _init() {
            self.cashDrawers = self.getCashDrawers();
            self.insurances = orderService.formatInsurancePricesForReport(self.orderForm.warrantyPrices, self.order);

            var filteredLeaserOptions = bdcTabacPresseService.getFilteredLeaserOptions(self.order);
            let filteredLeaserPrestations = bdcTabacPresseService.getFilteredLeaserPrestations(self.order);
            let filteredPurchasePrestations = bdcTabacPresseService.getFilteredPurchasePrestations(self.order);
            self.isLeasingScanup =
                filteredLeaserOptions.filter(option => option.optionType.code === 'SCANUP').length >0;
            self.isLeasingPrestationInstall =
                filteredLeaserPrestations.filter(option => option.optionType.code === 'PRESTATION'
                    && ['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO'].includes(option.code)).length > 0;
            self.isLeasingPrestationCateringSupport = filteredLeaserPrestations.filter(option => option.optionType.code === 'PRESTATION' &&
                ['RESTAURATION-ESSENTIEL', 'RESTAURATION-PREMIUM', 'RESTAURATION-ULTIMATE'].indexOf(option.code) !== -1);

            if (self.isOlderOffer === false) {
                self.order.cashDrawers.forEach(function(cashDrawer) {
                    cashDrawer.optionType = {
                        code: 'TIROIR_CAISSE'
                    };
                });
                self.leaserOptions = self.order.cashDrawers.concat(filteredLeaserOptions);
            }
            else {
                self.leaserOptions = filteredLeaserOptions;
            }

            self.leaserPrestations = filteredLeaserPrestations;
            self.purchasePrestations = filteredPurchasePrestations;

            // l'array buralogOptions n'est pas utilisé pour directement afficher les options
            self.buralogOptions = self.order.options.filter(orderService.checkOptionKey('billingTypeCode', 'BURALOG'));

            // On peuple les variables du tableau bdc avec les options restantes dans order.options
            for (var i = 0; i < self.order.options.length; i++) {
                // condition pour éviter d'afficher une 2ème fois les options déjà placées dans leaserOptions (exeption imprimantes car il y a le cas de l'imprimante supp avec l'id identique dupliqué dans order.options)
                if (
                    self.leaserOptions.find(
                        orderService.checkOptionKey('id', self.order.options[i].id) &&
                            orderService.checkOptionKey('optionType', self.order.options[i].optionType)
                    ) === undefined ||
                    self.order.options[i].optionType.code === 'IMPRIMANTE'
                ) {
                    switch (self.order.options[i].optionType.code) {
                        case 'IMPRIMANTE':
                            if (self.order.options[i].isAdditional) {
                                self.additionalPrinter = self.order.options[i];
                            }
                            else if (self.order.contract.contractType.code === 'ACHAT' && self.isOlderOffer === true) {
                                self.printer = self.order.options[i];
                            }
                            break;
                        case 'SCANUP':
                            if (self.order.options[i].isScanupDevice) {
                                self.scanup = self.order.options[i];
                            }
                            else {
                                self.scanupOptions.push(self.order.options[i]);
                            }
                            break;
                        case 'PRESTATION':
                            if(['INSTALLATION-SITE', 'INSTALLATION-SITE-STANDARD', 'INSTALLATION-SITE-HNO'].includes(self.order.options[i].code))
                                self.prestationInstall = self.order.options[i];
                            if (['RESTAURATION-ESSENTIEL', 'RESTAURATION-PREMIUM', 'RESTAURATION-ULTIMATE'].indexOf(self.order.options[i].code) !== -1)
                                self.prestationCateringSupport = self.order.options[i];
                            break;
                        case 'FLASHUP':
                            self.flashup.push(self.order.options[i]);
                            break;
                        case 'TPE':
                            if (self.order.options[i].isTPEDevice) {
                                if (self.order.options[i].nbOptions) {
                                    self.TPEs.push(self.order.options[i]);
                                }
                                if (self.order.options[i].nbOffered) {
                                    self.TPEsOffered.push(self.order.options[i]);
                                }
                            }
                            else {
                                self.TpeOptions.push(self.order.options[i]);
                            }
                            break;
                        case 'OPTSANSENG':
                            if (
                                self.order.options[i].code === 'B-BOOSTER' ||
                                self.order.options[i].code === 'PACK-B-BOOSTER'
                            ) {
                                self.BBoosterOptions.push(self.order.options[i]);
                            }
                            break;
                        case 'LOGICIEL':
                            self.TpeOptions.push(self.order.options[i]);
                            break;
                        case 'MAINTENANCE':
                            self.tillMaintenance.push(self.order.options[i]);
                            break;
                        case 'SAV':
                            self.sav.push(self.order.options[i]);
                            break;
                        case 'EXTENSION':
                            self.extension.push(self.order.options[i]);
                            break;
                        case 'GESTION_SCANUP':
                        case 'GESTION':
                            self.gestion.push(self.order.options[i]);
                            break;
                        case 'LOGICIEL_CAISSE':
                        case 'SERVICE_LOGICIEL':
                            self.software.push(self.order.options[i]);
                            break;
                        case 'ACCESSOIRE_CAISSE':
                            self.tillAccessories.push(self.order.options[i]);
                            break;
                        case 'PACK_BOULANGERIE':
                            self.packBoulangerie.push(self.order.options[i]);
                            break;
                        default:
                            self.options.push(self.order.options[i]);
                            break;
                    }
                }
            }
        }

        self.leaserOptionsFilter = function leaserOptionsFilter(option) {
            var typeValues = ['SCANUP', 'DEFAUT', 'ACCESSOIRE_CAISSE', 'IMPRIMANTE', 'EXTENSION', 'TIROIR_CAISSE'];
            return option.optionType ? typeValues.indexOf(option.optionType.code) > -1 : false;
        };

        self.leaserSoftwareFilter = (option) => {
            const typeValues = ['LOGICIEL_CAISSE'];
            return option.optionType ? typeValues.indexOf(option.optionType.code) > -1 : false;
        }

        self.leaserPrestationsFilter = function (option) {
            var typeValues = ['PRESTATION'];
            return option.optionType ? typeValues.indexOf(option.optionType.code) > -1 : false;
        };

        self.leaserOptionsOrder = function leaserOptionsOrder(option) {
            switch (option.optionType.code) {
                case 'TIROIR_CAISSE':
                    return 0;
                case 'ACCESSOIRE_CAISSE':
                    return 1;
                case 'IMPRIMANTE':
                    return 2;
                case 'SCANUP':
                    return 3;
                case 'DEFAUT':
                    return 4;
                case 'EXTENSION':
                    return 5;
                default:
                    return 10;
            }
        };

        self.displayLeaserOptionQuantity = function displayLeaserOptionQuantity(option) {
            if (self.isOlderOffer === true) {
                return option.optionType.code === 'ACCESSOIRE_CAISSE' ? self.nbTills : option.nbOptions;
            }
            else if (option.optionType.code === 'TIROIR_CAISSE') {
                return option.nbCashDrawers;
            }
            else {
                return option.nbOptions;
            }
        };

        self.displayLeaserOptionPrice = function displayLeaserOptionPrice(option, price) {
            if(option.isDependNbTills && price.nbTills !== self.nbTills) return false;
            if (option.optionType.code === 'TIROIR_CAISSE') {
                return pricesService.getCashDrawerUnitPrice(option) * option.nbCashDrawers;
            }

            var amount = option.nbOptions;
            if (self.isOlderOffer === true) {
                amount = option.optionType.code === 'ACCESSOIRE_CAISSE' ? self.nbTills : option.nbOptions;
            }
            let round = !['PC-PORTABLE-GESTION', 'ACCESSOIRE_CAISSE'].includes(option.optionType.code);
            round = ['IMPRIMANTE-TICKET-COMPTOIRE'].includes(option.code) ? false : round;
            return pricesService.getOptionUnitPrice(option, false, round) * amount;

        };

        self.isA4Printer = function () {
            return self.order.options.find(o => o.optionType.code === 'IMPRIMANTE' && o.label !== 'Pas d\'imprimante Bimedia (Utilisation imprimante perso)');
        }

        self.showOptionsCondition = function showOptionsCondition() {
            return (
                self.order.options.length > 0 &&
                (self.tillAccessories.length > 0 ||
                    self.printer !== null ||
                    self.additionalPrinter !== null ||
                    self.scanup !== null ||
                    self.scanupOptions.length > 0 ||
                    self.options.length > 0 ||
                    self.TpeOptions.length > 0 ||
                    self.extension.length > 0)
            );
        };

        self.showPrestationsCondition = function () {
            return (
                self.order.options.length > 0
                && ((self.prestationInstall !== null && self.prestationInstall.contractType.code === 'ACHAT')
                    ||(self.prestationCateringSupport !== null && self.prestationCateringSupport.contractType.code === 'ACHAT'))
                && self.order.contract.contractType.code !== 'ACHAT'
            );
        };

        self.filterPriceByContractTypeAndMarketType = function filterPriceByContractTypeAndMarketType(price) {
            if (
                price.type.code === self.order.contract.contractType.code &&
                price.marketType.code === self.order.marketType.code
            ) {
                return true;
            }
        };

        self.filterPriceAchatAndMarketType = function filterPriceAchatAndMarketType(price) {
            if (price.type.code === 'ACHAT' && price.marketType.code === self.order.marketType.code) {
                return true;
            }
        };

        self.displayPromotionSection = function displayPromotionSection() {
            if (self.order.offer.code === 'webTill') {
                return false;
            }
            if (self.order.marketType.code === 'BRASSERIE') {
                return false;
            }

            return true;
        };

        self.displayGoodwillGesturesSection = function () {
            const amounts = self.order.goodwillGestures && self.order.goodwillGestures.amount;
            if (!amounts) return false;
            const isAmounts = Object.entries(amounts)
                .filter(([key]) => !['mds', 'tpe', 'total', 'launchBimediaPay', 'exceptionalOffer', 'quickInstall', 'clubBimedia','clubBimediaEncaissementMobile'].includes(key))
                .some(([, value]) => value > 0)
            const positiveAmounts = Object.entries(amounts)
                .filter(([key, value]) => !['mds', 'tpe', 'total', 'launchBimediaPay', 'exceptionalOffer', 'quickInstall', 'clubBimedia'].includes(key) && value > 0);
            if (positiveAmounts.length === 1 && positiveAmounts[0][0] === 'revenue' && self.order.goodwillGestures.revenue.typeCode.indexOf('GLADY') > -1) {
                return false;
            }
            if (positiveAmounts.length === 1 && positiveAmounts[0][0] === 'moneyTransferServices' && self.order.goodwillGestures.moneyTransfer.clubBimedia) {
                return false;
            }
            return isAmounts;
        };

        self.displayGladySection = function () {
            let display = false;
            if (self.order.goodwillGestures) {
                if ((self.order.goodwillGestures.revenue && self.order.goodwillGestures.revenue.typeCode && self.order.goodwillGestures.revenue.typeCode.indexOf('GLADY') > -1)
                    || self.order.goodwillGestures.amount.clubBimediaEncaissementMobile > 0
                    || (!self.order.goodwillGestures.generosity.renunciationClubBimedia && self.order.goodwillGestures.amount.clubBimedia > 7))
                    display = true;
            }
            return display;
        }

        self.getOfferSubTotal = function () {
            const rateValue = self.order.goodwillGestures.revenue.rateValue || 0;
            const eagle = self.order.contract.contractType.code !== 'ACHAT'
                ? self.order.goodwillGestures.amount.eagle / self.getContractTypeValue
                : self.order.goodwillGestures.amount.eagle / 48;
            const moneyTransfer = self.order.goodwillGestures.amount
                ? self.order.contract.contractType.code !== 'ACHAT'
                    ? self.order.goodwillGestures.amount.moneyTransferServices
                    : self.order.goodwillGestures.amount.moneyTransferServices / 48
                : 0;
            const scanupService = self.order.goodwillGestures.amount.scanupServices
                ? self.order.contract.contractType.code === 'LOC60'
                    ? self.goodwillGesturesService.SCANUP_SERVICES_MONTHLY_AMOUNT_60
                    : self.order.contract.contractType.code === 'ACHAT'
                        ? self.goodwillGesturesService.SCANUP_SERVICES_TOTAL / 12
                        : self.goodwillGesturesService.SCANUP_SERVICES_MONTHLY_AMOUNT
                : 0;
            return rateValue + eagle + moneyTransfer + scanupService;
        }

        /* MoneyTransferService */

        function getMoneyTransferServices() {
            return self.order.goodwillGestures && self.order.goodwillGestures.moneyTransfer.enabled
                ? goodwillGesturesService.getMoneyTransferMonthlyPrice(self.order)
                : 0;
        }

        self.getMonthlyNetPrice = function () {
            const monthlyPrice = self.order.prices.total.rental
                - (self.order.flashupContractType.code === 'ACHAT' ? 0 : self.order.prices.flashup);
            const rateValue = self.order.goodwillGestures && self.order.goodwillGestures.revenue && self.order.goodwillGestures.revenue.typeCode
                && self.order.goodwillGestures.revenue.typeCode.indexOf('GLADY') === -1
                && self.order.goodwillGestures.revenue.rateValue ? self.order.goodwillGestures.revenue.rateValue : 0;
            const eagle = self.order.goodwillGestures ? self.order.contract.contractType.code !== 'ACHAT'
                ? self.order.goodwillGestures.amount.eagle / self.getContractTypeValue
                : self.order.goodwillGestures.amount.eagle / 48 : 0
            const moneyTransfer = self.order.goodwillGestures && self.order.goodwillGestures.moneyTransfer.clubBimedia === false
                ? self.order.contract.contractType.code !== 'ACHAT'
                    ? self.order.goodwillGestures.amount.moneyTransferServices
                    : self.order.goodwillGestures.amount.moneyTransferServices / 48
                : 0;
            const scanupService = self.order.goodwillGestures && self.order.goodwillGestures.amount.scanupServices
                ? self.order.contract.contractType.code === 'LOC60'
                    ? self.goodwillGesturesService.SCANUP_SERVICES_MONTHLY_AMOUNT_60
                    : self.order.contract.contractType.code === 'ACHAT'
                        ? self.goodwillGesturesService.SCANUP_SERVICES_TOTAL / 12
                        : self.goodwillGesturesService.SCANUP_SERVICES_MONTHLY_AMOUNT
                : 0;
            return monthlyPrice - rateValue - eagle - moneyTransfer - scanupService ;
        }

        self.getComptantNetPrice = function () {
            const price = self.order.prices.total.purchase;
            // const scanupServices = self.order.contract.contractType.code === 'ACHAT'
            // ? self.order.goodwillGestures.amount.scanupServices
            //     : self.order.contract.contractType.code !== 'LOC60' && self.order.goodwillGestures.amount.scanupServices
            //         ? self.goodwillGesturesService.SCANUP_SERVICES_MONTHLY_AMOUNT * 12
            //         : self.order.goodwillGestures.amount.scanupServices ? self.goodwillGesturesService.SCANUP_SERVICES_MONTHLY_AMOUNT_60 * 12 : 0;
            // const moneyTransfer = self.order.contract.contractType.code === 'ACHAT' ? self.order.goodwillGestures.amount.moneyTransferServices : 0;
            return price /* - scanupServices - moneyTransfer */;
        }

        _init();

        self.descriptionMT= 'Transformez votre activité <strong>MG + Ria + WU</strong> en points cadeaux ! Vos points sont calculés chaque trimestre en fonction de vos performances ' +
            'du trimestre précédent et permettent de couvrir tout ou partie de vos loyers caisses.'

        self.tillsMT = '<strong>Offre Caisse MT</strong><br><strong>* Moins de 180 transactions :</strong> 0 point cumulé.<br>' +
            '<strong>* Entre 180 et 270 transactions :</strong> Vous gagnez des points équivalents à <strong>50% de votre loyer</strong> (dans la limite de <strong>195 points</strong> / trimestre).<br>' +
            '<strong>* Entre 270 et 360 transactions :</strong> Vous gagnez des points équivalents à <strong>75% de votre loyer</strong> (dans la limite de <strong>292,5 points</strong> / trimestre).<br>' +
            '<strong>* Plus de 360 transactions :</strong> Vous gagnez des points équivalents à <strong>100% de votre loyer</strong> (dans la limite de <strong>390 points</strong> / trimestre).';
        
        self.scanupMT = '<strong>Offre Scanp\'up MT</strong><br><strong>* Moins de 45 transactions :</strong> 0 point cumulé.<br>' +
            '<strong>* Entre 45 et 90 transactions :</strong> Vous gagnez des points équivalents à <strong>50% de votre loyer</strong> (dans la limite de <strong>39 points</strong> / trimestre).<br>' +
            '<strong>* Plus de 90 transactions :</strong> Vous gagnez des points équivalents à <strong>100% de votre loyer</strong> (dans la limite de <strong>78 points</strong> / trimestre).';

        self.tillsMTExt = '<strong>Offre Caisse MT</strong><br><strong>* Moins de 180 transactions :</strong> 0 point cumulé.<br>' +
            '<strong>* Entre 180 et 270 transactions :</strong> Vous gagnez des points équivalents à <strong>50% de votre loyer</strong> (dans la limite de <strong>165 points</strong> / trimestre).<br>' +
            '<strong>* Entre 270 et 360 transactions :</strong> Vous gagnez des points équivalents à <strong>75% de votre loyer</strong> (dans la limite de <strong>24.5 points</strong> / trimestre).<br>' +
            '<strong>* Plus de 360 transactions :</strong> Vous gagnez des points équivalents à <strong>100% de votre loyer</strong> (dans la limite de <strong>330 points</strong> / trimestre).';
        return self;
    }

    BDCTabacPresseCtrl.$inject = [
        '$scope',
        '$window',
        '$rootScope',
        'pricesService',
        'commonService',
        'orderService',
        'marketService',
        'tillPackService',
        'boulangerieService',
        'offerService',
        'goodwillGesturesService',
        'promotionService',
        'bdcTabacPresseService',
        'userService'
    ];

    angular.module('app.bdc.reports.bdcTabacPresseCtrl', []).controller('BDCTabacPresseCtrl', BDCTabacPresseCtrl);
});
